import { ITEM_STATE_LOADING } from "../../constants";

export default (items, newItemState) => [
  ...items.map(item => ({
    ...item,
    itemState:
      item.itemState === ITEM_STATE_LOADING ? newItemState : item.itemState
  }))
];
